import { render, staticRenderFns } from "./KisiOzelYetkiDialog.vue?vue&type=template&id=6547a619&scoped=true"
import script from "./KisiOzelYetkiDialog.vue?vue&type=script&lang=ts"
export * from "./KisiOzelYetkiDialog.vue?vue&type=script&lang=ts"
import style0 from "./KisiOzelYetkiDialog.vue?vue&type=style&index=0&id=6547a619&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6547a619",
  null
  
)

export default component.exports